export default () => ({
  iconButton: {},
  iconContainer: {
    marginRight: '24px',
  },
});
